import { Theme, useTheme } from "@/components/theme/themeProvider"
import { cn } from "@/modules/lib/utils"
import { HustleupIcon } from "@images/hustleupIcon"

export function SplashScreen({ ...props }: React.HTMLAttributes<HTMLDivElement>) {
  const { theme } = useTheme()

  return (
    <div
      className={cn("bg-size-300% fixed top-0 left-0 z-9999 flex h-screen w-full items-center justify-center", {
        "animate-(--animate-pulsate-athlete)": theme !== Theme.OwnerDark,
        "animate-(--animate-pulsate-box)": theme === Theme.OwnerDark,
      })}
      {...props}
    >
      <HustleupIcon color="var(--primary-500)" />
    </div>
  )
}

export default SplashScreen
